import { INSERT , UPDATE} from "@/utils/database_module"
import { Versement } from "@/utils/types"

const payment = {

    insert : async (data : VersementData) => {
        return await INSERT("versement" , data)
    },

    update : async (id : number , data : VersementData) => {
        return await UPDATE("versement" , data , [{column : "id" , operator : "=" , value : id}])
     
    },
}

export default payment

type VersementData = {
    order_id?: number;
    payment_proof?: string;
    payment_method?: string;
    amount?: number;
    details?: string;
    status?: string;
    percentage?: number;
  };